module.exports = __webpack_public_path__ + "static/media/loading.326dc34f.gif";